import { render, staticRenderFns } from "./multiple-choice-grid.vue?vue&type=template&id=258f77da&"
import script from "./multiple-choice-grid.vue?vue&type=script&lang=js&"
export * from "./multiple-choice-grid.vue?vue&type=script&lang=js&"
import style0 from "./multiple-choice-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('258f77da')) {
      api.createRecord('258f77da', component.options)
    } else {
      api.reload('258f77da', component.options)
    }
    module.hot.accept("./multiple-choice-grid.vue?vue&type=template&id=258f77da&", function () {
      api.rerender('258f77da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/multiple-choice-grid.vue"
export default component.exports